import React, { useEffect, useState, useRef, useCallback } from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import { Button } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'

const Chat = ({ messages: _messages, onSend: _onSend }) => {
  const threadRef = useRef(null)
  const messageRef = useRef(null)
  const [message, setMessage] = useState('')
  const [messages, setMessages] = useState([])

  useEffect(() => setMessages(_messages), [_messages])

  const onSend = useCallback(() => {
    if (!message.length) {
      return window.alert('Message is empty!')
    }


    const nextMessage = {
      id: +Date.now(),
      timestamp: +Date.now() / 1000,
      body: message,
      recipient: { type: 4 },
    }

    setMessage('')
    setMessages([...messages, nextMessage])

    if (threadRef.current) {
      threadRef.current.scrollTop = threadRef.current.scrollHeight
    }
    
    _onSend(message)
  }, [message])


  return (
    <div className="w-full h-full flex flex-col">
      <div className="grow overflow-y-auto p-4 space-y-4" ref={threadRef}>
        { messages.map(({ id, timestamp, subject, body, recipient, sender }) => {
          return (
            <div key={id} className={classNames('flex', recipient?.type > 1 ? 'justify-end' : 'justify-start')}>
              <div className={classNames('w-2/3', recipient?.type > 1 ? '' : '')}>
                <p
                  tabIndex="0"
                  className={classNames(`
                    break-words
                    cursor-pointer
                    focus:border-primary-darker
                    focus:max-h-full
                    focus:outline-none
                    focus:ring
                    max-h-48
                    overflow-hidden
                    p-4
                    rounded-md
                    shadow-sm
                    text-sm
                    whitespace-pre-wrap`,
                    recipient?.type > 1
                      ? 'bg-secondary-darker hover:bg-secondary text-white'
                      : 'bg-gray-200 hover:bg-gray-300'
                  )}
                >
                  { body }
                </p>

                <div className="text-xs mt-1 w-full text-right px-1 text-gray-500 space-x-1">
                  { timestamp > 0 ? (
                    <>
                      <span><FormattedDate value={new Date(timestamp * 1000)} tagName="span" /></span>
                      <span><FormattedTime value={new Date(timestamp * 1000)} tagName="span" /></span>
                    </>
                  ) : (
                    <span>Unknown</span>
                  ) }
                </div>
              </div>
            </div>
          )
        }) }
      </div>

      <div className="p-4 flex justify-end">
        <div className="w-2/3">
          <textarea
            ref={messageRef}
            className="p-4 rounded-md text-sm border border-gray-300 w-full rounded-lg"
            value={message}
            onFocus={() => messageRef.current.classList.add('h-40')}
            onBlur={() => messageRef.current && messageRef.current.classList.remove('h-40')}
            onChange={({ target: { value } }) => setMessage(value)}
            placeholder="Start typing.."
          />
          
          <div className="text-right">
            <Button
              variant={message.length ? 'solid' : 'outline'}
              size='sm'
              disabled={!message.length}
              onClick={onSend}
            >
              Send
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Chat
